'use client';

import { Drawer, DrawerContent, DrawerTrigger } from '@shared/ui/drawer';
import { TBankLoadingModalProps } from '../model/types';
import { Content } from './Content';

export const BankLoadingDrawer = ({
  open,
  destination,
  onOpenChange,
  triggerElement,
}: TBankLoadingModalProps) => {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      {triggerElement && <DrawerTrigger asChild>{triggerElement}</DrawerTrigger>}
      <DrawerContent className={`w-full p-5 min-h-auto`}>
        <Content destination={destination} />
      </DrawerContent>
    </Drawer>
  );
};
